import { useEffect } from "react";

export function useShortcut(shortcutKeys, callback) {
  useEffect(() => {
    const handler = (event) => {
      // Example: shortcutKeys = { ctrl: true, key: 's' }
      if (
          (shortcutKeys.ctrl ? event.ctrlKey : true) &&
          (shortcutKeys.shift ? event.shiftKey : true) &&
          (shortcutKeys.alt ? event.altKey : true) &&
          event.key.toLowerCase() === shortcutKeys.key.toLowerCase()
      ) {
        event.preventDefault();
        callback(event);
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [shortcutKeys, callback]);
}